import { AUTH_ROUTE_NAME } from '@/libs/route-name';

export const signinRoute = () => {
    return {
        name: AUTH_ROUTE_NAME.SIGNIN,
        path: 'signin',
        component: () => import('@/pages/signin/index.vue'),
    };
};
